import { mergeStyles } from '@cian/utils';
import * as React from 'react';

import styles from './header.css';
import { CloseIcon } from '../../common/icons';

interface IGalleryHeaderProps {
  currentSlide: number;
  slidesCount: number;
  visible?: boolean;
  onClose(): void;
}

export const GalleryHeader = (props: IGalleryHeaderProps) => {
  const counter = `${props.currentSlide + 1}/${props.slidesCount}`;

  return (
    <header {...mergeStyles(styles['header'], !props.visible && styles['header_invisible'])}>
      <div className={styles['close_button_area']} onClick={() => props.onClose()}>
        <CloseIcon />
      </div>
      {counter}
    </header>
  );
};
